(function(){
  'use strict';

  function correctPro2Text(value){
    return String(value == null ? '' : value)
      .replace(/Left AirPod, A2699 or A3047/g,'Left AirPod, A2699 or A3048')
      .replace(/Right AirPod, A2698 or A3048/g,'Right AirPod, A2698 or A3047')
      .replace(/A2699 \/ A3047/g,'A2699 / A3048')
      .replace(/A2698 \/ A3048/g,'A2698 / A3047')
      .replace(/A2699 \/ A2698 \/ A2700 or A3047 \/ A3048 \/ A2968/g,'A2699 / A2698 / A2700 or A3048 / A3047 / A2968')
      .replace(/A2699, A2698, A2700, A3047, A3048, A2968/g,'A2699, A2698, A2700, A3048, A3047, A2968');
  }

  function fixFinder(){
    var root=document.querySelector('.airpods-finder');
    if(!root)return;

    var usbButton=root.querySelector('[data-finder-model="pro-2-usbc"]');
    if(usbButton){
      var details=usbButton.querySelectorAll('span,small');
      if(details[0])details[0].textContent='Left: A3048';
      if(details[1])details[1].textContent='Right: A3047';
      if(details[2])details[2].textContent='Case: A2968';
    }

    var selectedName=root.querySelector('#finder-selected-model-name');
    var usbSelected=selectedName&&/AirPods Pro 2nd Generation, USB C/i.test(selectedName.textContent||'');
    if(!usbSelected)return;

    var summary=root.querySelector('#finder-selected-summary');
    if(summary)summary.textContent='Left: A3048 | Right: A3047 | Case: A2968';

    var left=root.querySelector('[data-finder-part-key="left"] span');
    var right=root.querySelector('[data-finder-part-key="right"] span');
    var casePart=root.querySelector('[data-finder-part-key="usb-c-case"] span');
    if(left)left.textContent='A3048';
    if(right)right.textContent='A3047';
    if(casePart)casePart.textContent='A2968';

    var resultTitle=root.querySelector('#finder-result-title');
    var resultText=root.querySelector('#finder-result-text');
    if(resultTitle&&resultText&&/AirPods Pro 2nd Generation, USB C/i.test(resultTitle.textContent||'')){
      if(/Left AirPod/i.test(resultTitle.textContent||'')){
        resultText.textContent='You selected AirPods Pro 2nd Generation, USB C and need a Left AirPod. Model number to check: A3048.';
      }else if(/Right AirPod/i.test(resultTitle.textContent||'')){
        resultText.textContent='You selected AirPods Pro 2nd Generation, USB C and need a Right AirPod. Model number to check: A3047.';
      }else if(/Case/i.test(resultTitle.textContent||'')){
        resultText.textContent='You selected AirPods Pro 2nd Generation, USB C and need a MagSafe Charging Case, USB C. Compatible case model: A2968.';
      }
    }
  }

  function fixTradeIn(){
    var root=document.getElementById('trade-in-v52');
    if(!root)return;

    var modelButton=root.querySelector('[data-ti2-model="pro2"]');
    if(modelButton){
      var modelDetail=modelButton.querySelector('span');
      if(modelDetail)modelDetail.textContent='A2699, A2698, A2700, A3048, A3047, A2968';
    }

    var pro2Selected=modelButton&&modelButton.classList.contains('is-on');
    if(!pro2Selected)return;

    var left=root.querySelector('#ti2-left-label');
    var right=root.querySelector('#ti2-right-label');
    var casePart=root.querySelector('#ti2-case-label');
    var setPart=root.querySelector('#ti2-set-label');
    if(left)left.textContent='Left AirPod, A2699 or A3048';
    if(right)right.textContent='Right AirPod, A2698 or A3047';
    if(casePart)casePart.textContent='Charging Case, A2700 or A2968';
    if(setPart)setPart.textContent='Whole Set, Pro 2 Lightning or USB-C';

    var summary=root.querySelector('#ti2-summary');
    if(summary)summary.innerHTML=correctPro2Text(summary.innerHTML);
  }

  if(window.URLSearchParams&&URLSearchParams.prototype&&!URLSearchParams.prototype.__resetPro2Fixed){
    var nativeToString=URLSearchParams.prototype.toString;
    URLSearchParams.prototype.toString=function(){
      try{
        var model=this.get('model')||this.get('tradeInModel')||'';
        if(/AirPods Pro 2/i.test(model)){
          ['part','partOrItems','tradeInPart','modelNumber','tradeInModelNumber'].forEach(function(key){
            if(this.has(key))this.set(key,correctPro2Text(this.get(key)));
          },this);
        }
      }catch(error){}
      return nativeToString.call(this);
    };
    URLSearchParams.prototype.__resetPro2Fixed=true;
  }

  if(window.Storage&&Storage.prototype&&!Storage.prototype.__resetPro2Fixed){
    var nativeSetItem=Storage.prototype.setItem;
    Storage.prototype.setItem=function(key,value){
      if(/^airpartsTradeIn(?:Part|ModelNumber)$/.test(String(key||''))){
        value=correctPro2Text(value);
      }
      return nativeSetItem.call(this,key,value);
    };
    Storage.prototype.__resetPro2Fixed=true;
  }

  function runFixes(){
    fixFinder();
    fixTradeIn();
  }

  document.addEventListener('click',function(){setTimeout(runFixes,0);},true);
  document.addEventListener('change',function(){setTimeout(runFixes,0);},true);

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',runFixes,{once:true});
  }else{
    runFixes();
  }
})();
